import { PropsWithChildren } from "react";
import Box from "@mui/material/Box";
import { prefixWithBasePath } from "../../lib/asset";

export interface Props extends PropsWithChildren {
  top?: React.ReactNode;
}

/**
 * Wrapper for request access pages, comprised of a background image, a viewport
 * centered card and allows additional content before the background image body.
 *
 * Set `top` to a react node to display additional content before the background
 * image body.
 *
 * Children go into the viewport centered card.
 */
export function Wrapper({ top, children }: Props) {
  return (
    <>
      {top ? (
        <Box>
          <Box>{top}</Box>
        </Box>
      ) : null}
      <Box
        sx={{
          flex: 1,
          backgroundImage: `url(${prefixWithBasePath(
            "/assets/images/mycargill-landing.webp"
          )})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          minHeight: "90vh",
          pb: "4rem",
          mb: "1rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Box
          sx={(theme) => ({
            padding: { xs: 0, sm: theme.spacing(2) },
            display: "flex",
            justifyContent: "center",
            margin: "0 auto",
            width: { xs: "100%", sm: "500px" },
          })}
        >
          <Box
            sx={{
              width: "100%",
              backgroundColor: "rgba(255,255,255)",
              boxShadow: "1px 1px 10px #999",
              textAlign: "center",
              padding: "1rem 2rem 3rem 2rem",
            }}
          >
            <Box sx={{ margin: "0 auto", maxWidth: "500px" }}>{children}</Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
